// Centralised content for alu-ograde.ba (Bosnian)
export const BRAND = {
    name: "alu-ograde.ba",
    legalName: "alu-ograde.ba",
    phone: "061 340 345",
    phoneHref: "tel:+38761340345",
    email: "info@pelesic.com",
    address: "Tomislava Ramljaka 53, 75000 Tuzla, BiH",
    addressLocality: "Tuzla",
    addressCountry: "BA",
    postalCode: "75000",
    streetAddress: "Tomislava Ramljaka 53",
    hours: "Pon – Pet: 08:00 – 17:00",
    siteUrl: "https://alu-ograde.ba",
    description:
        "alu-ograde.ba — Aluminijske ograde po mjeri. Moderne alu ograde direktno od proizvođača. Bez održavanja, dugovječne, u 217 RAL boja. Dostava u BiH.",
};

export const NAV = [
    { label: "Modeli", href: "/#modeli" },
    { label: "Zašto aluminij", href: "/#zasto" },
    { label: "Boje", href: "/#boje" },
    { label: "Reference", href: "/#reference" },
    { label: "Katalog", href: "/katalog" },
    { label: "FAQ", href: "/#faq" },
    { label: "Kontakt", href: "/#kontakt" },
];

export const STATS = [
    { value: "10", label: "godina garancije" },
    { value: "217", label: "RAL boja" },
    { value: "15+", label: "godina iskustva" },
];

export const FEATURES = [
    {
        title: "Otporno na rđu i dugovječno",
        body: "Kvalitetan plastificirani aluminij — otporan na vremenske uslove i postojan u boji desetljećima.",
    },
    {
        title: "Bez održavanja",
        body: "Bez ponovnog farbanja i održavanja. Povremeno čišćenje vodom je sasvim dovoljno.",
    },
    {
        title: "Izrada po mjeri",
        body: "Svaka alu ograda se izrađuje individualno, prema vašim dimenzijama i željama.",
    },
    {
        title: "217 RAL boja",
        body: "Veliki izbor tonova prema RAL karti K7 — usklađenih s vašom fasadom i arhitekturom.",
    },
    {
        title: "Dostava u cijeloj BiH",
        body: "Direktna isporuka širom Bosne i Hercegovine, sa kratkim rokovima proizvodnje.",
    },
    {
        title: "Kompletan asortiman",
        body: "Prateći stupovi, kapije, šarke i brave — sve iz jedne ruke, bez traženja drugih dobavljača.",
    },
];

export const MODELS = [
    {
        n: "01",
        id: "lunar",
        name: "LUNAR",
        tag: "Aluminijska ograda sa lamelama",
        desc: "Aluminijska ograda sa lamelama 40×20 mm i modernim, ravnim dizajnom. Savršen balans elegancije i funkcionalnosti.",
        long: "Model LUNAR je visokokvalitetna aluminijska ograda sa lamelama, modernog i ravnog dizajna koji savršeno spaja eleganciju i funkcionalnost. Polja ograde čine stabilne aluminijske lamele 40 × 20 mm sa standardnim razmakom od 20 mm, što daje harmoničan izgled uz optimalnu zaštitu od pogleda. Okvir je izrađen od preciznog profila 30 × 26 mm sa kvalitetnim aluminijskim završnim kapama. LUNAR je idealan kao balkonska ograda, ograda parcele i vrta, kao i za klizne i krilne kapije.",
        img: "https://www.smart-mak.com/wp-content/uploads/2026/02/aluminium-lamellenzaun-lunar-700-800px.png",
        bullets: [
            "Lamele 40 × 20 mm, standardni razmak 20 mm",
            "Okvirni profil 30 × 26 mm sa aluminijskim završnim kapama",
            "Idealno za ogradu, balkonsku ogradu i kapije",
            "Otporno na koroziju i bez održavanja",
        ],
        techData: [
            ["Materijal", "Plastificirani aluminij"],
            ["Standardne visine", "100 / 120 / 150 cm"],
            ["Standardna boja", "RAL 7016 – Antracit siva"],
            ["Izbor boja", "217 boja prema RAL K7"],
            ["Garancija", "10 godina"],
            ["Montaža", "Uključeno uputstvo, moguća kaskadna montaža"],
        ],
        specs: [
            { k: "Lamele", v: "40 × 20 mm horizontalno" },
            { k: "Razmak lamela", v: "10 / 20 / 40 mm" },
            { k: "Standardne visine", v: "800 / 1000 / 1200 / 1400 / 1600 / 1800 mm" },
            { k: "Maks. dužina polja", v: "do 2500 mm" },
            { k: "Završna obrada", v: "Plastifikacija RAL K7 (217 boja)" },
            { k: "Garancija", v: "10 godina" },
        ],
        highlights: [
            "Klasičan, vremenski neprolazan dizajn",
            "Uska lamela 40 × 20 mm — diskretan izgled",
            "Mogućnost izbora razmaka (zatvoreno / poluotvoreno)",
            "Idealno za prednje i bočne ograde",
        ],
        gallery: [
            { src: "https://customer-assets.emergentagent.com/job_fence-bih-market/artifacts/261scqmu_aluminium-balkongelaender-mit-pfosten-in-ral7016.jpg", alt: "LUNAR — aluminijska balkonska ograda u RAL 7016 antracit siva" },
            { src: "https://customer-assets.emergentagent.com/job_fence-bih-market/artifacts/qxxos5lk_alu-zaun-ausfuehrung-mit-au%C3%9Fenliegendem-zaunfeld-und-innenliegenden-pfosten.jpg", alt: "LUNAR — izvedba sa vanjskim poljem i unutrašnjim stupovima u dekoru drveta" },
            { src: "https://customer-assets.emergentagent.com/job_fence-bih-market/artifacts/03md9qac_alu-zaun-lunar-mit-au%C3%9Fenliegendem-zaunfeld-und-innenliegenden-pfosten.jpg", alt: "LUNAR — ograda parcele sa horizontalnim lamelama u antracit boji" },
        ],
    },
    {
        n: "02",
        id: "stellar",
        name: "STELLAR",
        tag: "Ograda sa širokim lamelama",
        desc: "Premium aluminijska ograda sa širokim lamelama 100×20 mm i individualnim razmakom.",
        long: "Model STELLAR je premium aluminijska ograda sa širokim horizontalnim lamelama dimenzija 100 × 20 mm, što daje masivan i moderan izgled. Razmak između lamela je prilagodljiv tako da možete birati između potpuno zatvorenog izgleda za maksimalnu privatnost i poluotvorenog rješenja za bolju prozračnost.",
        img: "https://www.smart-mak.com/wp-content/uploads/2026/02/aluminium-zaun-mit-breiten-lamellen-stellar-700-800px-1.png",
        bullets: [
            "Široke lamele 100 × 20 mm sa prilagodljivim razmakom",
            "Premium izgled za savremenu arhitekturu",
            "Slobodan izbor razmaka — od zatvorenog do otvorenog",
            "Otporno na koroziju i bez održavanja",
        ],
        techData: [
            ["Materijal", "Plastificirani aluminij"],
            ["Standardne visine", "120 / 140 / 160 / 180 cm"],
            ["Standardna boja", "RAL 7016 – Antracit siva"],
            ["Izbor boja", "217 boja prema RAL K7"],
            ["Garancija", "10 godina"],
            ["Montaža", "Uključeno uputstvo, moguća kaskadna montaža"],
        ],
        specs: [
            { k: "Lamele", v: "100 × 20 mm horizontalno" },
            { k: "Standardne visine", v: "1000 / 1200 / 1400 / 1600 / 1800 mm" },
            { k: "Maks. dužina polja", v: "do 2500 mm" },
            { k: "Završna obrada", v: "Plastifikacija RAL K7" },
            { k: "Garancija", v: "10 godina" },
        ],
        highlights: [
            "Moderni izgled sa širokim lamelama",
            "Slobodan izbor razmaka — od potpuno zatvorenog do otvorenog",
            "Kombinira se sa kapijama u istom dizajnu",
        ],
        gallery: [
            { src: "https://customer-assets.emergentagent.com/job_fence-bih-market/artifacts/dxrealn9_aluminium-lattenzaun-stellar-mit-pfosten.jpg", alt: "STELLAR — lamelna ograda sa stupovima u antracit boji" },
            { src: "https://customer-assets.emergentagent.com/job_fence-bih-market/artifacts/62d363ry_aluminium-sichtschutzzaun-stellar-in-anthrazitgrau-fuer-pool.jpg", alt: "STELLAR — neprozirna ograda u antracit sivoj oko bazena" },
            { src: "https://customer-assets.emergentagent.com/job_fence-bih-market/artifacts/f78h9f0v_aluminium-sichtschutzzaun-stellar-montage-auf-betonsockel.jpg", alt: "STELLAR — montaža na betonskom soklu uz baštu" },
        ],
    },
    {
        n: "03",
        id: "astral",
        name: "ASTRAL",
        tag: "Vertikalna šipkasta ograda",
        desc: "Elegantan sistem sa vertikalnim šipkama 40×20 ili 60×20 mm. Idealno kao balkonska ograda i zaštita parcele.",
        long: "Model ASTRAL je elegantna vertikalna šipkasta ograda — bezvremenski klasik sa modernim aluminijskim profilima. Vertikalne šipke su dostupne u dimenzijama 40 × 20 mm ili 60 × 20 mm, sa razmakom prilagođenim normi za balkonske ograde (do 100 mm). Najčešće se koristi kao balkonska ograda, ograda terase ili oko bazena, ali odlično funkcioniše i kao dvorišna ograda kada se traži otvoreniji vizualni efekat i bolja prozračnost.",
        img: "https://www.smart-mak.com/wp-content/uploads/2026/02/aluminium-zaun-astral-mit-zeitloser-vertikaler-linienfuehrung-700-800px.png",
        bullets: [
            "Vertikalne šipke 40 × 20 mm ili 60 × 20 mm",
            "Razmak usklađen sa normom za balkonske ograde (≤ 100 mm)",
            "Idealno za balkone, terase i ograde oko bazena",
            "Otporno na koroziju i bez održavanja",
        ],
        techData: [
            ["Materijal", "Plastificirani aluminij"],
            ["Standardne visine", "90 / 100 / 110 / 120 cm (balkon) · 140–180 cm (parcela)"],
            ["Standardna boja", "RAL 7016 – Antracit siva"],
            ["Izbor boja", "217 boja prema RAL K7"],
            ["Garancija", "10 godina"],
            ["Montaža", "Uključeno uputstvo, vanjska ili integrisana stupovska"],
        ],
        specs: [
            { k: "Šipke", v: "40 × 20 mm ili 60 × 20 mm vertikalno" },
            { k: "Razmak šipki", v: "po normi za balkonske ograde (≤ 100 mm)" },
            { k: "Standardne visine", v: "900 / 1000 / 1100 / 1200 mm (balkon) · 1400–1800 mm (parcela)" },
            { k: "Maks. dužina polja", v: "do 3000 mm" },
            { k: "Završna obrada", v: "Plastifikacija RAL K7" },
            { k: "Garancija", v: "10 godina" },
        ],
        highlights: [
            "Idealno za balkonske ograde — usklađeno sa normama",
            "Otvoren, prozračan izgled",
            "Pogodno za bazene i terase",
            "Niska cijena po dužnom metru",
        ],
        gallery: [
            { src: "https://customer-assets.emergentagent.com/job_fence-bih-market/artifacts/ay99uzvr_alu-zaun-astral-balkongelaender-in-anthrazit.jpg", alt: "ASTRAL — balkonska ograda u antracit boji" },
            { src: "https://customer-assets.emergentagent.com/job_fence-bih-market/artifacts/32ngo1jc_alu-zaun-astral-balkongelaender-staebe-20x20.jpg", alt: "ASTRAL — balkonska ograda sa šipkama 20×20 mm" },
            { src: "https://customer-assets.emergentagent.com/job_fence-bih-market/artifacts/bk3n2hsz_alu-zaun-mit-senkrechter-fuellung-modell-astral.jpg", alt: "ASTRAL — ograda parcele sa vertikalnim ispunjenjem" },
        ],
    },
    {
        n: "04",
        id: "eclipse",
        name: "ECLIPSE",
        tag: "Aluminijska panel ograda",
        desc: "Robusna aluminijska panel ograda sa Z-lamelama 110×15 mm — maksimalna privatnost uz diskretnu cirkulaciju zraka.",
        long: "Model ECLIPSE je najpopularniji izbor za one kojima je privatnost na prvom mjestu. Z-profilisane lamele dimenzija 110 × 15 mm postavljene su tako da potpuno blokiraju pogled, ali zadržavaju diskretnu cirkulaciju zraka kroz skrivene otvore. Time se izbjegava efekat tunela i smanjuje opterećenje vjetrom, a istovremeno imate potpuno zatvoreno i mirno dvorište.",
        img: "https://www.smart-mak.com/wp-content/uploads/2026/02/aluminium-sichtschutzzaun-eclipse-700-800px.png",
        bullets: [
            "Z-profil lamele 110 × 15 mm — potpuno zatvoreno",
            "Skrivena cirkulacija zraka kroz profil",
            "Smanjuje buku i opterećenje vjetrom",
            "Otporno na koroziju i bez održavanja",
        ],
        techData: [
            ["Materijal", "Plastificirani aluminij"],
            ["Standardne visine", "150 / 170 / 180 / 200 cm"],
            ["Standardna boja", "RAL 7016 – Antracit siva"],
            ["Izbor boja", "217 boja prema RAL K7"],
            ["Garancija", "10 godina"],
            ["Montaža", "Uključeno uputstvo, moguća kaskadna montaža"],
        ],
        specs: [
            { k: "Lamele", v: "110 × 15 mm Z-profil" },
            { k: "Razmak lamela", v: "0 mm (potpuno zatvoreno) sa skrivenim ventilacionim otvorima" },
            { k: "Standardne visine", v: "1500 / 1700 / 1800 / 2000 mm" },
            { k: "Maks. dužina polja", v: "do 2500 mm" },
            { k: "Završna obrada", v: "Plastifikacija RAL K7" },
            { k: "Garancija", v: "10 godina" },
        ],
        highlights: [
            "Maksimalna privatnost — neproziran pogled",
            "Diskretna cirkulacija zraka kroz Z-profil",
            "Smanjuje buku iz okoline",
            "Otpornost na vjetar (smanjeno opterećenje)",
        ],
        gallery: [
            { src: "https://customer-assets.emergentagent.com/job_fence-bih-market/artifacts/mr4cuijx_aluminium-sichschutzzaun-modell-eclipse-in-ral7016.jpg", alt: "ECLIPSE — neprozirna ograda RAL 7016 antracit u dvorištu" },
            { src: "https://customer-assets.emergentagent.com/job_fence-bih-market/artifacts/wkukze1t_aluminium-sichschutzzaun-modell-eclipse-in-weissaluminium.jpg", alt: "ECLIPSE — neprozirna ograda u bijelom aluminiju" },
            { src: "https://customer-assets.emergentagent.com/job_fence-bih-market/artifacts/xngcbwfy_lamelle-eclipse-z-110.jpg", alt: "ECLIPSE — Z-profil lamela 110 mm, detalj presjeka" },
        ],
    },
    {
        n: "05",
        id: "orbit",
        name: "ORBIT",
        tag: "Premium · horizontalne lamele 40×30 mm",
        desc: "Ekskluzivni premium sistem sa horizontalnim profilima 40×30 mm i elegantnim, zatvorenim izgledom.",
        long: "Model ORBIT je premium sistem za zahtjevne klijente koji traže najviši nivo dizajna i kvaliteta. Pojačani profili 40 × 30 mm daju ogradi masivnost i karakter, a istovremeno održavaju modernu, čistu liniju. ORBIT je naš preporučeni izbor za reprezentativne ulaze, vile i poslovne objekte — često se kombinuje sa kliznim ili krilnim kapijama u istom dizajnu.",
        img: "https://www.smart-mak.com/wp-content/uploads/2026/02/aluminium-premium-zaunsystem-orbit-mit-waagerechten-lamellen-700-800px.png",
        bullets: [
            "Premium horizontalne lamele 40 × 30 mm",
            "Reprezentativan izgled za vile i poslovne objekte",
            "Velika dužina polja — manje stupova vidljivo",
            "Otporno na koroziju i bez održavanja",
        ],
        techData: [
            ["Materijal", "Plastificirani aluminij (premium profil)"],
            ["Standardne visine", "120 / 140 / 160 / 180 / 200 cm"],
            ["Standardna boja", "RAL 7016 – Antracit siva"],
            ["Izbor boja", "217 boja prema RAL K7"],
            ["Garancija", "10 godina"],
            ["Montaža", "Uključeno uputstvo, moguća kaskadna montaža"],
        ],
        specs: [
            { k: "Lamele", v: "40 × 30 mm horizontalno (premium profil)" },
            { k: "Razmak lamela", v: "10 / 20 mm" },
            { k: "Standardne visine", v: "1200 / 1400 / 1600 / 1800 / 2000 mm" },
            { k: "Maks. dužina polja", v: "do 3000 mm" },
            { k: "Završna obrada", v: "Plastifikacija RAL K7" },
            { k: "Garancija", v: "10 godina" },
        ],
        highlights: [
            "Premium profil 40 × 30 mm sa pojačanom strukturom",
            "Reprezentativan izgled za vile i poslovne objekte",
            "Velika maksimalna dužina polja — manje stupova",
            "Usklađeno sa kliznim i krilnim kapijama",
        ],
        gallery: [
            { src: "https://customer-assets.emergentagent.com/job_a708df4e-9925-43fe-a63c-ae2453af62f8/artifacts/wf7qz9m0_premium-alu-zaun-mit-gehtuere-orbit.jpg", alt: "ORBIT — premium alu ograda sa pješačkom kapijom" },
            { src: "https://customer-assets.emergentagent.com/job_a708df4e-9925-43fe-a63c-ae2453af62f8/artifacts/wzve1jgq_premium-alu-zaun-orbit-mit-lamellen-40x30.jpg", alt: "ORBIT — premium ograda sa lamelama 40×30" },
            { src: "https://customer-assets.emergentagent.com/job_a708df4e-9925-43fe-a63c-ae2453af62f8/artifacts/yabho86g_premium-alu-zaun-und-toranlage-orbit.jpg", alt: "ORBIT — premium ograda i kapija" },
        ],
    },
    {
        n: "06",
        id: "galactic",
        name: "GALACTIC",
        tag: "Premium · vertikalne lamele 40×30 mm",
        desc: "Premium sistem sa vertikalnim lamelama 40×30 mm i opcionom horizontalnom blendom — za markantnu arhitekturu.",
        long: "Model GALACTIC je naš najekskluzivniji sistem — premium ograda sa vertikalnim lamelama 40 × 30 mm koje stvaraju snažan vertikalni ritam. Opcionalno dolazi sa horizontalnom designblendom na vrhu ili dnu polja, što ogradi daje arhitektonski karakter. Idealno za moderne kuće sa minimalističkom estetikom i savremene poslovne objekte.",
        img: "https://www.smart-mak.com/wp-content/uploads/2026/02/aluminium-premium-zaunsystem-mit-vertikaler-linienfuehrung-galactic-700-800px.png",
        bullets: [
            "Premium vertikalne lamele 40 × 30 mm",
            "Opcionalna horizontalna designblenda na vrhu/dnu polja",
            "Vertikalni ritam — markantna arhitektonska linija",
            "Otporno na koroziju i bez održavanja",
        ],
        techData: [
            ["Materijal", "Plastificirani aluminij (premium profil)"],
            ["Standardne visine", "140 / 160 / 180 / 200 / 220 cm"],
            ["Standardna boja", "RAL 7016 – Antracit siva"],
            ["Izbor boja", "217 boja prema RAL K7"],
            ["Garancija", "10 godina"],
            ["Montaža", "Uključeno uputstvo, moguća kaskadna montaža"],
        ],
        specs: [
            { k: "Lamele", v: "40 × 30 mm vertikalno (premium profil)" },
            { k: "Razmak lamela", v: "10 / 20 / 40 mm" },
            { k: "Standardne visine", v: "1400 / 1600 / 1800 / 2000 / 2200 mm" },
            { k: "Maks. dužina polja", v: "do 3000 mm" },
            { k: "Dodaci", v: "Opcionalna horizontalna designblenda" },
            { k: "Završna obrada", v: "Plastifikacija RAL K7" },
            { k: "Garancija", v: "10 godina" },
        ],
        highlights: [
            "Najimpresivniji vizualni efekat — vertikalni ritam",
            "Opcionalna horizontalna blenda za arhitektonski karakter",
            "Visoki polja do 2200 mm bez nadograđivanja",
            "Savršeno uz minimalističke i bauhaus kuće",
        ],
        gallery: [
            { src: "https://customer-assets.emergentagent.com/job_a708df4e-9925-43fe-a63c-ae2453af62f8/artifacts/5m8n40w5_aluminium-tor-mit-vertikaler-fuellung-in%20anthrazit-galactic.jpg", alt: "GALACTIC — aluminijska kapija sa vertikalnom ispunom u antracit boji" },
            { src: "https://customer-assets.emergentagent.com/job_a708df4e-9925-43fe-a63c-ae2453af62f8/artifacts/yyqv2mng_aluminium-zaun-mit-vertikaler-fuellung-in%20anthrazit-galactic.jpg", alt: "GALACTIC — detalj vertikalnih lamela u antracit boji" },
            { src: "https://customer-assets.emergentagent.com/job_a708df4e-9925-43fe-a63c-ae2453af62f8/artifacts/81zt4s4c_aluminium-zaun-modern-mit-vertikalen-staeben-galactic.jpg", alt: "GALACTIC — moderna ograda sa vertikalnim štapovima" },
        ],
    },
    {
        n: "07",
        id: "infinity",
        name: "INFINITY",
        tag: "Premium · aluminijski profil 60×40 mm",
        desc: "Minimalistička ograda sa vertikalnim profilima 60×40 mm — čist linijski dizajn, idealna za montažu na betonski cokl.",
        long: "Model INFINITY je naša ograda od aluminijskih profila dimenzija 60 × 40 mm. Dostupna je u dvije varijante — klasična pravougaona (razmak 60 mm) i romboidna (razmak 55 mm). Minimalistička estetika i jasne vertikalne linije daju ogradi moderan i lagan izgled. Idealna za montažu na betonski cokl. U isporuku su uključeni aluminijski poklopci za profil 60 × 40 mm i poklopci za podni profil.",
        img: "https://customer-assets-lxgj4vgw.emergentagent.net/job_a708df4e-9925-43fe-a63c-ae2453af62f8/artifacts/f9rfg4he_infinity-700-800px.png",
        bullets: [
            "Aluminijski profili 60 × 40 mm, debljina stijenke 2,5 mm",
            "Dvije varijante: klasična (razmak 60 mm) i romb (razmak 55 mm)",
            "Podni profil 90 × 50 mm, debljina stijenke 4 mm",
            "Standardno u boji RAL 7016 – Antracit siva",
        ],
        techData: [
            ["Materijal", "Plastificirani aluminij"],
            ["Standardne visine", "100 / 120 / 150 cm"],
            ["Standardna boja", "RAL 7016 – Antracit siva"],
            ["Izbor boja", "217 boja prema RAL K7"],
            ["Garancija", "10 godina"],
            ["Montaža", "Idealno na betonskom coklu; moguća kaskadna izvedba"],
        ],
        specs: [
            { k: "Profili", v: "60 × 40 mm aluminij, debljina stijenke 2,5 mm" },
            { k: "Varijante", v: "Klasična (razmak 60 mm) · Romb (razmak 55 mm)" },
            { k: "Podni profil", v: "90 × 50 mm, debljina stijenke 4 mm" },
            { k: "Standardne visine", v: "1000 / 1200 / 1500 mm" },
            { k: "Posebne visine", v: "Po zahtjevu kupca" },
            { k: "Uključeno u isporuci", v: "Poklopci za profil i podni profil" },
            { k: "Završna obrada", v: "Plastifikacija RAL K7" },
            { k: "Garancija", v: "10 godina" },
        ],
        highlights: [
            "Minimalistička estetika sa čistim vertikalnim linijama",
            "Dvije varijante — klasična ili romboidna",
            "Idealno za montažu na betonski cokl",
            "Moguća stepenasta montaža za nagib terena",
        ],
        gallery: [
            { src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_a708df4e-9925-43fe-a63c-ae2453af62f8/artifacts/4at3robk_alu-stelen-zaun-mak-1.jpg", alt: "INFINITY — realizovan projekt ispred moderne kuće" },
            { src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_a708df4e-9925-43fe-a63c-ae2453af62f8/artifacts/spvd720d_alu-stelen-zaun-mak-2.jpg", alt: "INFINITY — ograda sa vertikalnim profilima uz bazen" },
            { src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_a708df4e-9925-43fe-a63c-ae2453af62f8/artifacts/mgsbk9a8_alu-stelen-zaun-mak-3.jpg", alt: "INFINITY — vertikalni profili u antracit boji sa vrtnom uređenošću" },
        ],
    },
];

export const COLORS = [
    { ral: "RAL 7016", name: "Antracit siva", hex: "#373F43" },
    { ral: "RAL 9005", name: "Duboko crna", hex: "#0A0A0A" },
    { ral: "RAL 9006", name: "Bijeli aluminij", hex: "#A5A8A6" },
    { ral: "RAL 9016", name: "Saobraćajna bijela", hex: "#F1F1EA" },
    { ral: "RAL 8017", name: "Čokoladno smeđa", hex: "#44322D" },
    { ral: "RAL 6005", name: "Mahovinasto zelena", hex: "#114232" },
    { ral: "RAL 7024", name: "Grafitno siva", hex: "#2C3235" },
    { ral: "RAL 3003", name: "Rubin crvena", hex: "#84232B" },
];

export const GALLERY = [
    {
        src: "https://customer-assets.emergentagent.com/job_aluminum-fence-demo/artifacts/zofi94as_SATURN_OBJAVA_5-2%20%281%29.jpg",
        label: "STELLAR · Panel",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_a708df4e-9925-43fe-a63c-ae2453af62f8/artifacts/yabho86g_premium-alu-zaun-und-toranlage-orbit.jpg",
        label: "ORBIT · Kapija & ograda",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_a708df4e-9925-43fe-a63c-ae2453af62f8/artifacts/81zt4s4c_aluminium-zaun-modern-mit-vertikalen-staeben-galactic.jpg",
        label: "GALACTIC · Vertikalna",
    },
    {
        src: "https://www.smart-mak.com/wp-content/uploads/2026/02/aluminium-sichschutzzaun-modell-eclipse-in-ral7016.jpg",
        label: "ECLIPSE · Neprozirna",
    },
    {
        src: "https://www.smart-mak.com/wp-content/uploads/2026/02/alu-zaun-astral-balkongelaender-in-anthrazit.jpg",
        label: "ASTRAL · Balkonska",
    },
    {
        src: "https://www.smart-mak.com/wp-content/uploads/2026/02/alu-zaun-lunar-mit-ausenliegendem-zaunfeld-und-innenliegenden-pfosten.jpg",
        label: "LUNAR · Lamele",
    },
];

export const FAQS = [
    {
        q: "Koliko dugo traje aluminijska ograda?",
        a: "Naše aluminijske ograde su plastificirane i otporne na vremenske uslove. Uz redovno povremeno čišćenje, traju desetljećima bez gubitka kvaliteta boje i strukture — zbog čega dajemo 10 godina garancije.",
    },
    {
        q: "Da li je aluminijska ograda zaista bez održavanja?",
        a: "Da. Za razliku od drvenih ili čeličnih ograda, alu ograda ne rđa i ne treba ponovno farbanje. Dovoljno je povremeno pranje vodom i blagim sredstvom za čišćenje.",
    },
    {
        q: "Da li se ograda izrađuje po mjeri?",
        a: "Svaka ograda se proizvodi prema vašim dimenzijama. Dolazimo na uviđaj, uzimamo mjere i pripremamo rješenje koje se uklapa u vaš prostor i arhitekturu.",
    },
    {
        q: "Koje boje su dostupne?",
        a: "Na raspolaganju su vam sve 217 nijansi iz RAL karte K7. Najčešće biramo RAL 7016 (antracit), RAL 9005 (crna) i RAL 9006 (bijeli aluminij), ali moguća je bilo koja boja.",
    },
    {
        q: "Da li postoje kapije koje se uklapaju sa ogradom?",
        a: "Da. U ponudi su klizne i krilne kapije, ulazne pješačke kapije, kao i kompletan pribor — motori, šarke, brave i interfoni. Sve je usklađeno sa dizajnom ograde.",
    },
    {
        q: "Koliko košta aluminijska ograda?",
        a: "Cijena ovisi o modelu, visini, dužini i dodacima. Pošaljite upit sa okvirnim dimenzijama — u roku od 24h dobit ćete besplatnu i neobavezujuću ponudu.",
    },
    {
        q: "Da li vršite dostavu i montažu u BiH?",
        a: "Da. Dostavljamo i montiramo ograde u cijeloj Bosni i Hercegovini. Tim iskusnih monteri dolazi na adresu i garantuje pravilnu ugradnju.",
    },
];
